module.exports = __webpack_public_path__ + "static/media/menu.8a941551.svg";